import _extends from "@babel/runtime/helpers/extends";
import { Button, Empty, Table } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useStores } from "../../../store";
import { IMPREZA_BUTTON_PROPS, __, _i } from "../../../utils";
const {
  Column
} = Table;
const AccountInvoicesTable = observer(() => {
  const {
    accountStore: {
      session
    }
  } = useStores();
  const {
    busyInvoices,
    invoices,
    hasEnvatoPurchase
  } = session;
  useEffect(() => {
    session.fetchInvoices();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, __("Below you will find all invoices for orders placed on devowl.io. The invoices are partly issued by our Merchant of Record, through which purchase contracts may have been made."), " ", hasEnvatoPurchase && _i(__("For products you have purchased on codecanyon.net, you can view the invoice only on {{i}}{{a}}codecanyon.net{{/a}} > username (top right) as a logged in user > Profiles > Statements (tab){{/i}}."), {
    a: /*#__PURE__*/React.createElement("a", {
      href: "https://codecanyon.net/",
      target: "_blank",
      rel: "noreferrer"
    }),
    i: /*#__PURE__*/React.createElement("i", null)
  })), /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    locale: {
      emptyText: /*#__PURE__*/React.createElement(Empty, {
        description: __("No data")
      })
    },
    pagination: false,
    loading: busyInvoices,
    dataSource: Array.from(invoices.values()),
    rowKey: row => row.data.invoiceUrl,
    size: "small",
    showHeader: invoices.length > 0
  }, /*#__PURE__*/React.createElement(Column, {
    title: __("Subscription"),
    dataIndex: "subscription",
    key: "subscription",
    render: (_, _ref) => {
      let {
        data: {
          productPlan: {
            name,
            description
          }
        }
      } = _ref;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, name), /*#__PURE__*/React.createElement("br", null), description);
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Invoice date"),
    dataIndex: "invoiceDate",
    key: "invoiceDate",
    render: (_, _ref2) => {
      let {
        data: {
          createdAt
        }
      } = _ref2;
      return new Date(createdAt).toLocaleDateString(document.documentElement.lang);
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Total"),
    dataIndex: "total",
    key: "total",
    align: "right",
    width: 200,
    render: (_, _ref3) => {
      let {
        data: {
          currency
        },
        labelTotal
      } = _ref3;
      return `${currency} ${labelTotal}`;
    }
  }), /*#__PURE__*/React.createElement(Column, {
    title: __("Actions"),
    dataIndex: "actions",
    key: "actions",
    align: "right",
    width: 200,
    render: (_, _ref4) => {
      let {
        data: {
          invoiceUrl,
          invoiceUrlPdf
        }
      } = _ref4;
      return /*#__PURE__*/React.createElement(React.Fragment, null, invoiceUrl ? /*#__PURE__*/React.createElement(Button, _extends({
        type: "primary",
        onClick: () => {
          window.open(invoiceUrl, "_blank");
        }
      }, IMPREZA_BUTTON_PROPS, {
        style: {
          marginLeft: "5px"
        }
      }), __("Open")) : null, invoiceUrlPdf ? /*#__PURE__*/React.createElement(Button, _extends({
        type: "primary",
        onClick: () => {
          window.open(invoiceUrlPdf, "_blank");
        }
      }, IMPREZA_BUTTON_PROPS, {
        style: {
          marginLeft: "5px"
        }
      }), __("Download")) : null);
    }
  })));
});
export { AccountInvoicesTable };